import Helpers from '@helpers';

const videoResize = () => {

    window.addEventListener("load", function () {
        var videos = document.querySelectorAll("p > iframe");
        for (var i = 0; i < videos.length; i++) {
            var video = videos[i];
            var videoAddress = video.getAttribute("src");
            if (!videoAddress.startsWith("https://vid.meghdadit.com")) {
                continue;
            }

            video.setAttribute('fullscreen', 'true');
            video.setAttribute('allowfullscreen', 'true');
            video.setAttribute('mozallowfullscreen', 'true');
            video.setAttribute('webkitallowfullscreen', 'true');   // width with padding

            var widthRegex = /width=(\d)*/;
            var heightRegex = /height=(\d)*/;
            var computedStyle = getComputedStyle(video.parentElement);
            var elementWidth = video.parentElement.clientWidth;

            if (elementWidth < 540) {

                elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
                videoAddress = videoAddress.replace(widthRegex, "width=" + elementWidth.toString());
                videoAddress = videoAddress.replace(heightRegex, "height=" + (elementWidth / (1920.0 / 1080.0)).toString());

                video.setAttribute("src", videoAddress);
                video.setAttribute("width", elementWidth.toString());
                video.setAttribute("height", (elementWidth / (1920.0 / 1080.0)).toString());

                var style = video.getAttribute("style");
                var styleRegex = /height:(\d)*/;
                if (style) {
                    style = style.replace(styleRegex, "height=" + (elementWidth / (1920.0 / 1080.0)).toString());
                    video.setAttribute("style", style);
                }
            }

            video.parentElement.innerHTML = video.parentElement.innerHTML;
        }
    });

};

export {
    videoResize
};
